export const PADDING_INNER_CONTAINER_X = 'px-4 sm:px-6 md:px-8'
export const PADDING_INNER_CONTAINER_Y = 'py-8' // TODO
export const PADDING_WRAPPER_CONTAINER_X = '' // TODO
export const PADDING_WRAPPER_CONTAINER_Y = '' // TODO
